import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import {
    PANEL_ANIMATION_DURATION_STRING,
    PANEL_ANIMATION_EASING,
} from "app/pages/sales-intelligence/common-components/animations";

import type { IPanelTheme } from "./types";

const COLLAPSED_WIDTH = 48;
const CONTENT_FADE_DURATION = "200ms";
const CONTENT_FADE_IN_DELAY = "50ms";

export const DEFAULT_COLLAPSIBLE_PANEL_THEME: IPanelTheme = {
    background: colorsPalettes.carbon[0],
    collapsedBackground: colorsPalettes.carbon[25],
    gapX: "12px",
    gapY: "8px",
};

export const StyledCollpsiblePanelContentWrap = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 150px;
    position: relative;
`;

export const StyledCollapsiblePanelInner = styled.div`
    border-bottom-width: 0;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
`;

export const StyledCollapsedBarWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 1;
`;

interface IStyledCollapsiblePanelProps {
    width: number;
    theme?: IPanelTheme;
    $isExpanded: boolean;
}

export const StyledCollapsiblePanel = styled.aside.attrs<IStyledCollapsiblePanelProps>((props) => ({
    ...props,
    theme: props.theme ?? DEFAULT_COLLAPSIBLE_PANEL_THEME,
}))`
    position: relative;
    width: ${({ width, $isExpanded }) => ($isExpanded ? width : COLLAPSED_WIDTH)}px;
    height: 100%;
    min-height: 200px;
    border-radius: 8px;
    background: ${({ theme, $isExpanded }) => ($isExpanded ? theme.background : theme.collapsedBackground)};
    transition:
        background ${PANEL_ANIMATION_DURATION_STRING} ${PANEL_ANIMATION_EASING},
        width ${PANEL_ANIMATION_DURATION_STRING} ${PANEL_ANIMATION_EASING};

    & ${StyledCollpsiblePanelContentWrap} {
        opacity: ${({ $isExpanded }) => ($isExpanded ? 1 : 0)};
        visibility: ${({ $isExpanded }) => ($isExpanded ? "visible" : "hidden")};
        transition:
            opacity ${CONTENT_FADE_DURATION} ease-in
                ${({ $isExpanded }) => ($isExpanded ? CONTENT_FADE_IN_DELAY : "0ms")},
            visibility 0s linear ${({ $isExpanded }) => ($isExpanded ? "0ms" : CONTENT_FADE_DURATION)};
    }

    & ${StyledCollapsedBarWrapper} {
        opacity: ${({ $isExpanded }) => ($isExpanded ? 0 : 1)};
        visibility: ${({ $isExpanded }) => ($isExpanded ? "hidden" : "visible")};
        transition:
            opacity ${CONTENT_FADE_DURATION} ease-in
                ${({ $isExpanded }) => ($isExpanded ? "0ms" : CONTENT_FADE_IN_DELAY)},
            visibility 0s linear ${({ $isExpanded }) => ($isExpanded ? CONTENT_FADE_DURATION : "0ms")};
    }
`;
